import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import { connect } from "react-redux"
import * as actions from "../../store/actions/navigationActions"
import "./InsNavigation.scss"

class InsNavigation extends Component {
  // _isActive = (match, location, to ) => {

  //   // verif si match (match: link actuel == link active)
  //   if (match) {
  //     // maj redux persistor (garde en memoire le lien)
  //     this.props.updatePath(match.url)
  //     return true
  //   }
  //   //si aucune des conditions précédentes est rempli on verif l'ancien lien en mémoire (old redux)
  //   return((!this.props.navigation.path && to === '/' ) || this._checkPathNameRedux(to))
  // }

  // _checkPathNameRedux = (pathname) => {
  //   const  {path} = this.props.navigation;
  //   if(path === "/"){
  //     return false
  //   }
  //   return(`/${pathname.split('/')[1]}` === path)

  // }

  render() {
    const {
      account,
      account: {
        validated = false,
        baGiftshop = false,
        ongoingSessions = false,
        upcomingSessions = false
      },
      t,
      config,
      config: {
        shopEnabled = false,
      },
    } = this.props;

    return (
      <>
        <div className="padding-navigation"></div>
        <div
          className={"ins_navigation five"
            // account.isForwork ? "ins_navigation five" : "ins_navigation four"
          }>
          <NavLink
            exact
            to={{
              pathname: "/",
              state: { transitionName: "fade_app" },
            }}
            activeClassName="active"
            className="home_link"
            isActive={(match, location) => {
              return match || location.pathname.startsWith('/news')
            }}>
            home
          </NavLink>
          {config.features.brands_enabled ? (
            <NavLink
              to={{
                pathname: "/brands",
                state: { transitionName: "fade_app" },
              }}
              activeClassName="active"
              className="ins_brands">
              {t("brands")}
            </NavLink>
          ) : null}
          {/* {config.features.learning_enabled ? (
            <NavLink
              to={{
                pathname: "/formations",
                state: { transitionName: "fade_app" },
              }}
              activeClassName="active"
              className="ins_formations">
              {t("formations")}
            </NavLink>
          ) : null} */}
          {config.features.social_wall_enabled && account.validated ? (
            <NavLink
              to={{
                pathname: "/wall",
                state: { transitionName: "fade_app" },
              }}
              activeClassName="active"
              className="ins_wall">
              {t("wall")}
            </NavLink>
          ) : null}

          {(shopEnabled &&
            validated &&
            baGiftshop &&
            (ongoingSessions || upcomingSessions)) ? (
            <NavLink
              to={{
                pathname: "/shop",
                state: { transitionName: "fade_app" },
              }}
              activeClassName="active"
              className="ins_shop">
              {t("shop")}
            </NavLink>
          ) : null}


          <NavLink
            to={{
              pathname: "/search",
              state: { transitionName: "fade_app" },
            }}
            activeClassName="active"
            className="ins_search">
            {t("search")}
          </NavLink>
        </div>
      </>
    )
  }
}

//extract data from the redux store
const mapStateToProps = (state) => ({
  navigation: state.navigation,
  account: state.account,
  config: state.config,
})

//Au changement de path on envoie l'action du updataPath avec le path actuel au store redux
const mapDispatchToProps = (dispatch) => {
  return {
    updatePath: (path) => {
      dispatch(actions.updatePath(path))
    },
    updatePathBrand: (bool) => {
      dispatch(actions.updatePathBrand(bool))
    },
  }
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(InsNavigation)
)
